<template>
  <b-container v-if="forbidden">
    <ForbiddenBanner/>
  </b-container>
  <b-container v-else>
    <RunnersWithoutTeamsAlert :globalData="globalData"/>
    <b-row class="text-left">
      <b-col>
        <h2>Programs</h2>
        <h5 class="text-secondary">
          <font-awesome-icon icon="sitemap" size="1x"/>
          {{ globalData.currentOrganization.name }}
        </h5>
      </b-col>
    </b-row>
    <b-row class="border shadow-lg user-select-none bg-light text-left mt-2 pt-2 pb-2" align-v="center">
      <b-col md="7" lg="5">
        <b-form-input
            autofocus
            v-model="filter"
            placeholder="Search Programs"
            autocomplete="off"
        />
      </b-col>
      <b-col cols="3">
        <b-form-checkbox class="text-right" v-model="showInactive" size="lg" switch @change="refresh()">
          Show inactive
        </b-form-checkbox>
      </b-col>
      <b-col cols="4" align-h="end" class="text-right">
        <b-button variant="success" class="mr-1" @click="onCreateProgram">Create</b-button>
      </b-col>
    </b-row>
    <br/>

    <b-table
        class="text-left"
        hover
        small
        :items="programs"
        :fields="fields"
        :filter="filter"
        :filter-included-fields="['name']"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @row-hovered="onRowHovered"
        @row-unhovered="onRowUnHovered"
    >
      <template #cell(name)="data">
        <router-link :to="{ name: 'program', params: { uuid: data.item.uuid }}">{{ data.item.name }}</router-link>
        <b-badge class="ml-2" v-if="! data.item.active">Inactive</b-badge>
      </template>
      <template #cell(startDate)="data">
        {{ dateFormatter.format(parseDate(data.item.startDate)) }}
      </template>
      <template #cell(weeks)="data">
        {{ weekCount(data.item) }}
      </template>
      <template #cell(workouts)="data">
        {{ workoutCount(data.item) }}
      </template>
      <template #cell(timestamp)="data">
        {{ timestampFormatter.format(data.item.timestamp) }}
      </template>

      <template #cell(actions)="data">
        <font-awesome-icon
            v-if="data.index === hoveredIndex"
            class="row-button mr-2"
            :class="data.item.active ? 'text-secondary' : 'text-primary'"
            :icon="data.item.active ? 'trash' : 'trash-restore'"
            :title="data.item.active ? 'Deactivate' : 'Activate'"
            size="1x"
            @click.stop="onToggleProgramState(data.item)"
        />
      </template>
    </b-table>
  </b-container>
</template>

<script>
import ForbiddenBanner from "@/components/ForbiddenBanner";
import ForbiddenContentMixin from "@/components/ForbiddenContentMixin";
import ProgramMixin from "@/components/Programs/ProgramMixin";
import RunnersWithoutTeamsAlert from "@/components/Admin/RunnersWithoutTeamsAlert";

export default {

  name: 'ProgramList',
  mixins: [ForbiddenContentMixin, ProgramMixin],
  components: {
    ForbiddenBanner,
    RunnersWithoutTeamsAlert,
  },
  data() {
    return {
      filter: "",
      showInactive: false,
      sortBy: 'startDate',
      sortDesc: true,
      fields: [
        {key: 'name', sortable: true, label: 'Program Name'},
        {key: 'startDate', sortable: true, label: 'Starts'},
        {key: 'weeks', sortable: false, class: "d-none d-sm-table-cell"},
        {key: 'workouts', sortable: false, class: "d-none d-sm-table-cell"},
        {key: 'timestamp', sortable: true, label: 'Modified', class: "d-none d-md-table-cell"},
        {key: 'actions', sortable: false, label: '', thStyle: {width: "60px"},},
      ],
      programs: [],
      timestampFormatter: new Intl.DateTimeFormat('default', {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false
      }),
      hoveredIndex: null,
    }
  },
  watch: {
    globalData: {
      handler() {
        this.refresh();
      },
      deep: true
    },
  },
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.$http.get('/api/programs', {params: {'showInactive': this.showInactive}})
          .then(response => {
            this.forbidden = false;
            response.data.forEach(item => {
              item.timestamp = Date.parse(item.lastModified)
            })
            this.programs = response.data
          })
          .catch(e => {
            this.HandleResponse(e)
          })
    },
    onRowHovered(item, index) {
      this.hoveredIndex = index;
    },
    onRowUnHovered() {
      this.hoveredIndex = null;
    },
    onCreateProgram() {
      this.$http.post('/api/programs')
          .then(response => {
            this.$router.push({name: 'program', params: {uuid: response.data.uuid}});
          })
          .catch(e => {
            console.warn(e)
          })
    },
    onToggleProgramState(program) {
      this.$http.post(`/api/programs/${program.uuid}/activate`, {active: !program.active})
          .then(() => {
            this.refresh();
          })
          .catch(e => {
            console.warn(e)
          })
    },
  }
}
</script>

<style scoped>
.row-button {
  cursor: pointer;
}
</style>
